import { Wheat, Carrot, Milk, Flame, Package, Droplet, Coffee, Croissant, Snowflake, SprayCan, NotebookPen, Apple, UtensilsCrossed, ShoppingBasket, Candy, LayoutGrid, Columns2, Rows3 } from "lucide-react";
import { metalFill } from "@/components/sales/SalesQuickFilter";

const ICONS = [[/veg/i, Carrot], [/fruit/i, Apple], [/dairy|milk|paneer|curd/i, Milk], [/spice|masala|condiment/i, Flame], [/pack|container|dispos/i, Package],
  [/oil|ghee/i, Droplet], [/tea|coffee|bever|drink/i, Coffee], [/bak|bread/i, Croissant], [/frozen/i, Snowflake], [/clean|hygien/i, SprayCan],
  [/station/i, NotebookPen], [/sugar|sweet/i, Candy], [/grocer|grain|rice|dal|pulse|flour|atta/i, Wheat]];
export const catIcon = (c) => (ICONS.find(([re]) => re.test(c || "")) || [null, UtensilsCrossed])[1];

export function CategoryBlocks({ rows, value, onChange, sub, testid = "fc-cat" }) {
  const cats = {};
  rows.forEach((r) => { const c = r.category || "Uncategorized"; cats[c] = (cats[c] || 0) + 1; });
  const list = [["", rows.length], ...Object.entries(cats).sort((a, b) => a[0].localeCompare(b[0]))];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3" data-testid={`${testid}-blocks`}>
      {list.map(([c, n], i) => {
        const Icon = c ? catIcon(c) : ShoppingBasket;
        const active = (value || "") === c;
        return (
          <button key={c || "all"} type="button" onClick={() => onChange(c)} className={`bi-tile !min-h-[96px] !flex-row !items-center gap-3 ${active ? "ring-4 ring-[#F4D58D] scale-[1.02]" : ""}`}
            style={{ "--bi-fill": metalFill(i), animationDelay: `${Math.min(i, 12) * 25}ms` }} aria-pressed={active} data-testid={`${testid}-${(c || "all").replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
            <Icon className="h-7 w-7 sm:h-9 sm:w-9 shrink-0 text-[#F4D58D]" />
            <span className="flex min-w-0 flex-col text-left">
              <span className="break-words text-base font-bold leading-tight">{c || "All Categories"}</span>
              <span className="text-sm opacity-90">{n} item{n === 1 ? "" : "s"}</span>
              {sub && <span className="text-xs opacity-90">{sub(c)}</span>}
            </span>
          </button>);
      })}
    </div>
  );
}

export function ViewSwitch({ view, setView, testid = "fc-view", labels = ["Category View", "Full Grid", "Both"] }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {[["cards", labels[0], LayoutGrid], ["grid", labels[1], Rows3], ["both", labels[2], Columns2]].map(([k, l, I]) => (
        <button key={k} type="button" className="bi-pill" data-active={view === k} onClick={() => setView(k)} data-testid={`${testid}-${k}`}><I className="h-4 w-4" />{l}</button>))}
    </div>
  );
}

export function MetalKpi({ i, label, value, sub, Icon, testid }) {
  return (
    <div className="bi-tile !flex-row !items-center gap-4 !min-h-[118px]" style={{ "--bi-fill": metalFill(i), animationDelay: `${i * 30}ms` }} data-testid={testid}>
      {Icon && <Icon className="h-11 w-11 shrink-0 text-[#F4D58D]" />}
      <span className="flex min-w-0 flex-col">
        <span className="bi-tile-label">{label}</span>
        <span className="bi-tile-value !text-[1.75rem] truncate">{value}</span>
        {sub && <span className="text-sm opacity-90">{sub}</span>}
      </span>
    </div>
  );
}

export const TONE_CARD = { green: "border-emerald-300 bg-emerald-50", amber: "border-[#e2b85a] bg-[#fff7e3]", yellow: "border-[#e2b85a] bg-[#fff7e3]", red: "border-red-300 bg-red-50", orange: "border-red-300 bg-red-50" };
export const TONE_LABEL = { green: "Sufficient", yellow: "Review", amber: "Review", red: "Critical", orange: "Critical" };
